import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  InputAdornment,
  IconButton,
  Divider,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import DialogHeader from "app/components/common/DialogHeader";
import { CustomTextField } from "assets/styles/globalStyledComponent";

const ChangePasswordDialog = ({
  open,
  setpasswordShow,
  resetForm,
  setShowPasswords,
  showPasswords,
  isMobile,
  handleSubmit,
  handleChange,
  values,
  touched,
  errors,
  changePasswordWithoutOtpLoading,
}) => {
  const handleClose = () => {
    setpasswordShow(false);
    resetForm();
    setShowPasswords({ current: false, new: false, confirm: false });
  };

  return (
    <Dialog
      open={Boolean(open)}
      onClose={handleClose}
      fullScreen={Boolean(isMobile)}
      PaperProps={{
        sx: {
          minWidth: isMobile ? "100%" : "400px",
          maxWidth: isMobile ? "100%" : "500px",
        },
      }}
    >
      <DialogTitle sx={{ p: "0 !important" }}>
        <DialogHeader title="Change Password" handleClose={handleClose} />
      </DialogTitle>

      <DialogContent>
        <form onSubmit={handleSubmit} id="changePassword">
          <Grid container spacing={2.5} sx={{ pt: 2 }}>
            <Grid item xs={12}>
              <Typography className="heading" sx={{ mb: 0.5, fontWeight: 500, fontSize: "14px" }}>
                Current Password <span style={{ color: "red" }}>*</span>
              </Typography>
              <CustomTextField
                size="small"
                fullWidth
                type={showPasswords.current ? "text" : "password"}
                name="currentPassoword"
                value={values.currentPassoword}
                onChange={handleChange}
                placeholder="Enter current password"
                error={Boolean(errors.currentPassoword) && touched.currentPassoword}
                helperText={touched.currentPassoword && errors.currentPassoword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPasswords((prev) => ({ ...prev, current: !prev.current }))}
                        edge="end"
                        size="small"
                      >
                        {showPasswords.current ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography className="heading" sx={{ mb: 0.5, fontWeight: 500, fontSize: "14px" }}>
                New Password <span style={{ color: "red" }}>*</span>
              </Typography>
              <CustomTextField
                size="small"
                fullWidth
                type={showPasswords.new ? "text" : "password"}
                name="newPassword"
                value={values.newPassword}
                onChange={handleChange}
                placeholder="Enter new password"
                error={Boolean(errors.newPassword) && touched.newPassword}
                helperText={touched.newPassword && errors.newPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPasswords((prev) => ({ ...prev, new: !prev.new }))}
                        edge="end"
                        size="small"
                      >
                        {showPasswords.new ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography className="heading" sx={{ mb: 0.5, fontWeight: 500, fontSize: "14px" }}>
                Confirm New Password <span style={{ color: "red" }}>*</span>
              </Typography>
              <CustomTextField
                size="small"
                fullWidth
                type={showPasswords.confirm ? "text" : "password"}
                name="confirmNewPassword"
                value={values.confirmNewPassword}
                onChange={handleChange}
                placeholder="Confirm new password"
                error={Boolean(errors.confirmNewPassword) && touched.confirmNewPassword}
                helperText={touched.confirmNewPassword && errors.confirmNewPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPasswords((prev) => ({ ...prev, confirm: !prev.confirm }))}
                        edge="end"
                        size="small"
                      >
                        {showPasswords.confirm ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>

      <Divider />

      <DialogActions>
        <LoadingButton
          onClick={handleClose}
          variant="outlined"
          color="secondary"
          disabled={changePasswordWithoutOtpLoading}
          size="medium"
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          form="changePassword"
          type="submit"
          loading={changePasswordWithoutOtpLoading}
          variant="contained"
          color="secondary"
          size="medium"
        >
          Update Password
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordDialog;
